import { render, staticRenderFns } from "./AdminApiUsage.vue?vue&type=template&id=665c5188&scoped=true"
import script from "./AdminApiUsage.vue?vue&type=script&lang=js"
export * from "./AdminApiUsage.vue?vue&type=script&lang=js"
import style0 from "./AdminApiUsage.vue?vue&type=style&index=0&id=665c5188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665c5188",
  null
  
)

export default component.exports